
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Samstag ist Migränetag. An diesem Wochentag leiden statistisch die meisten
Migräniker. Erst im April 2019 erschien in der Fachzeitschrift «Acta Neurologica
Scandinavica» eine aktuelle `}<Link href='https://www.ncbi.nlm.nih.gov/pubmed/30636039' mdxType="Link">{`Studie`}</Link>{` dazu.
Forscher untersuchten die Daten von über 44’000 Migräneattacken von 1085
Teilnehmern. Die Teilnehmer zeigten zwar unterschiedliche individuelle Muster
für die Verteilung ihrer Migräneattacken. Doch für einen grösseren Teil von
ihnen (195 von 1085) schien der Samstag tatsächlich der vorherrschende Tag für
Migräneanfälle zu sein. Auch in früheren Studien stellte sich der Samstag als
typischer Migränetag heraus. Möglicherweise deshalb, weil sie am Freitag später
ins Bett gehen und/oder samstags später aufstehen und das den gewohnten Rhythmus
stört. Eine typische Migränezeit ist übrigens früh am Morgen, aus dem Schlaf
heraus.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;